import React, { useCallback, useState } from "react";
import clsx from "clsx";
import ModalDepartureDate, {
  ModalDepartureDateProps
} from "./ModalDepartureDate";
import * as styles from "./OpenModalDepartureDateButton.module.scss";
import { useCurrentRefinements } from "react-instantsearch";
import { useLanguage } from "src/utils/localization/languages/I18nContext";
import { buildSelectedValuesLabel } from "../Filters/DepartureDateFilter";

type Props = ModalDepartureDateProps & {
  label: string;
  emptyPlaceholder?: string;
};

const OpenModalDepartureDateButton: React.FC<Props> = (props) => {
  const [modalIsMounted, setModalIsMounted] = useState(false);
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const language = useLanguage();

  const { items } = useCurrentRefinements({
    includedAttributes: ["departureYearMonth"]
  });
  const valuesLabel = buildSelectedValuesLabel(
    items?.[0]?.refinements,
    language
  );
  const label = props.label;

  const emptyPlaceholder = props.emptyPlaceholder || label;

  const hasSelection = items?.[0]?.refinements?.length > 0;

  const openModal = useCallback(() => {
    setModalIsMounted(true);
    setModalIsVisible(true);
  }, []);

  return (
    <React.Fragment>
      <button
        className={clsx(styles.labelsContainer, {
          [styles.withSelection]: hasSelection
        })}
        onClick={openModal}
      >
        <label className={styles.label}>
          {hasSelection ? label : emptyPlaceholder}
        </label>
        <div className={styles.valuesLabel}>{valuesLabel}</div>
      </button>

      {modalIsMounted && (
        <ModalDepartureDate
          {...props}
          title={label}
          modal={{
            onRequestClose: () => setModalIsVisible(false)
          }}
          isVisible={modalIsVisible}
          dataContentName="modal_filters_when"
        />
      )}
    </React.Fragment>
  );
};

export default OpenModalDepartureDateButton;
